import { AnyAction, Dispatch } from 'redux';
import { services } from "redux/services";
import { ParamsState, ServiceState } from 'utils/types';
import {
    GET_MASTER_PAGINATION_DATA_START,
    GET_MASTER_PAGINATION_DATA_SUCCESS,
    GET_MASTER_PAGINATION_DATA_FAIL,
    RESET_MASTER_PAGINATION_DATA
} from "../actionTypes";

// getMasterPaginationData is only for those api which have paginated data
// with custom filters
export function getMasterPaginationData(serviceType: keyof typeof services, payload: ParamsState):any {
    return (dispatch: Dispatch<AnyAction>) => {
        let actionService:any = services as unknown as ServiceState;

        if (actionService[serviceType]) {
            dispatch({ type: GET_MASTER_PAGINATION_DATA_START, serviceType });
            actionService[serviceType](payload)
                .then((res:any) => {
                    const { result, status } = res;
                    dispatch({ type: GET_MASTER_PAGINATION_DATA_SUCCESS, payload: result ? result : { items: [], count: 0 }, serviceType });
                })
                .catch(() => {
                    dispatch({ type: GET_MASTER_PAGINATION_DATA_FAIL, serviceType });
                });
        }
    };
}

export function resetMasterPaginationData() {
    return (dispatch: Dispatch<AnyAction>) => {
        dispatch({ type: RESET_MASTER_PAGINATION_DATA });
    };
}